import React, { useContext } from "react";
import {FormattedMessage} from "react-intl";
import FormatDate from "../../Utils/FormatDate";
import classes from "./styles.module.css";

import Context from "../../../Context";

function MobileCard({data, currentId}) {
    var safeData = data || {};
    var isSelected = currentId === safeData.id;
    var status = {
        name: "",
        color: "",
    };

    switch (safeData.status) {
        case -1:
            status.name = <FormattedMessage id="AccountsList.status.inactive" defaultMessage="Не активна"/>;
            status.color = "#ff9900";
            break;
        case -2:
            status.name = <FormattedMessage id="AccountsList.status.closed" defaultMessage="Закрыт"/>;
            status.color = "#d4d4d4";
            break;
        case -3:
            status.name = <FormattedMessage id="AccountsList.status.blocked" defaultMessage="Заблокирован"/>;
            status.color = "rgb(220, 57, 18)";
            break;
        case 1:
            status.name = <FormattedMessage id="AccountsList.status.active" defaultMessage="Активен"/>;
            status.color = "rgb(16, 150, 24)";
            break;
        default:
            break;
    }

    var {onSelectAccountId} = useContext(Context);

    return (
        <div
            className={classes.MobileCard}
            onClick={() => onSelectAccountId(safeData.id)}
            role="button"
            style={isSelected ? {borderBottomColor: status.color} : null}
        >
            <div className={classes.MobilePrimary}>
                <span className={classes.MobileName}>
                    {`${safeData.firstName || ""} ${safeData.patronymic || ""} ${safeData.lastName || ""}`.trim() || "-"}
                </span>
                <span className={classes.MobileStatus} style={{color: status.color}}>
                    {status.name || "-"}
                </span>
            </div>

            <div className={classes.MobileMetaRow}>
                <span className={classes.MobileMeta}>#{safeData.id}</span>
                <span className={classes.MobileMeta}>
                    <FormatDate
                        setDate={safeData.date}
                        format={{
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                        }}
                    />
                </span>
            </div>

            <div className={classes.MobileField}>
                <span className={classes.MobileValue}>{safeData.email || "-"}</span>
            </div>
        </div>
    );
}

export default MobileCard;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AccountsList/MobileCard.js